import Vue from 'vue'
import CreateAPI from 'vue-create-api'

Vue.use(CreateAPI);

const files = require.context('../components/api', false, /\.vue$/);
const importFn = require.context('../components/api', false, /\.vue$/)

files.keys().forEach(path => {
    const component = importFn(path).default;
    Vue.createAPI(component, false)
    // Vue.component(component.name, component)
})


// WEBPACK FOOTER //
// ./src/createApi/index.js